import buttoncss from "./../../css/button.module.css";
import Modal from "./../../elements/Modal";
import { Button } from "./../../elements/Button";
import Dropdown from "./../../elements/Dropdown";
import InputGroup from "./../../elements/InputGroup";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";

const ChecklistModal = ({ setShowChecklistModal, modalData }) => {
  const header = modalData.header;
  const libRefList = modalData.libRef;

  return (
    <Modal
      title={header}
      width="50%"
      headerActions={
        <CloseIcon
          onClick={() => {
            setShowChecklistModal(false);
          }}
          className="clickable"
        />
      }
      // footerActions={
      //   <> If it is not dont by 14 Dec, you are not going to institue
      //     <Button
      //       btnColor={buttoncss.secondary}
      //       onClick={() => { 
      //         setShowChecklistModal(false);
      //       }}
      //       label="Close"
      //     />
      //   </>
      // }
      onClose={() => console.log("Modal Closed")}
    >
      <div>
        {libRefList &&
          libRefList.map((item, obj) => (
            <>
            <span>
              <b>{obj + 1}.</b> {item}
            </span>
            <br/>
            </>
          ))}
      </div>
    </Modal>
  );
};

export default ChecklistModal;